var _path, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6838 5.23765C13.629 5.07307 13.5466 4.90863 13.4644 4.74405L13.6564 3.07126L11.9287 1.34364L10.256 1.53563C10.0914 1.45341 9.92693 1.39846 9.76235 1.31623L8.72031 0H6.27969L5.23765 1.31623C5.07307 1.37105 4.90863 1.4534 4.74405 1.53563L3.07126 1.34364L1.34364 3.07126L1.53563 4.74405C1.45341 4.90863 1.39846 5.07307 1.31623 5.23765L0 6.27969V8.72031L1.31623 9.76235C1.37105 9.92693 1.4534 10.0914 1.53563 10.256L1.34364 11.9287L3.07126 13.6564L4.74405 13.4644C4.90863 13.5466 5.07307 13.6015 5.23765 13.6838L6.27969 15H8.72031L9.76235 13.6838C9.92693 13.629 10.0914 13.5466 10.256 13.4644L11.9287 13.6564L13.6564 11.9287L13.4644 10.256C13.5466 10.0914 13.6015 9.92693 13.6838 9.76235L15 8.72031V6.27969L13.6838 5.23765ZM7.51371 12.0656C4.99086 12.0656 2.96162 10.0364 2.96162 7.51352C2.96162 4.99067 4.99086 2.96143 7.51371 2.96143C10.0366 2.96143 12.0658 4.99067 12.0658 7.51352C12.0658 10.0364 10.0366 12.0656 7.51371 12.0656Z",
    fill: "url(#paint0_linear_2553_74)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 1.5,
    fill: "url(#paint1_linear_2553_74)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2553_74",
    x1: 0,
    y1: 7.5,
    x2: 15,
    y2: 7.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2553_74",
    x1: 6,
    y1: 7.5,
    x2: 9,
    y2: 7.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9F20"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.b533f115af10dbd51d2494c30ac34520.svg";
export { ForwardRef as ReactComponent };